import { render, staticRenderFns } from "./FarmsHome.vue?vue&type=template&id=4023d604&scoped=true&"
import script from "./FarmsHome.vue?vue&type=script&lang=ts&"
export * from "./FarmsHome.vue?vue&type=script&lang=ts&"
import style0 from "./farms-home.scss?vue&type=style&index=0&id=4023d604&lang=scss&scoped=true&"
import style1 from "./FarmsHome.vue?vue&type=style&index=1&id=4023d604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4023d604",
  null
  
)

export default component.exports